<template>
  <div class="z-card">
    <h4>{{ $t('pbx.contact.table.field.contact_methods') }}</h4>

    <div class="z-card__body">
      <template v-if="is_allow_create_contact_method">
        <z-form-group class="row align-items-center">
          <label class="col-2 text-right">
            {{ $t('pbx.contact.table.field.label') }}
          </label>

          <div class="col-10">
            <z-form-input>
              <icon-select v-model="form.label" />
            </z-form-input>
          </div>
        </z-form-group>

        <z-form-group class="row">
          <label class="col-2 text-right">
            {{ $t('pbx.contact.table.field.contact_method') }}
          </label>

          <div class="col-10">
            <smart-select-contact-method
              :exist="contact_methods"
              class="form-input"
              @on-add="add_contact_method"
            />
          </div>
        </z-form-group>
      </template>

      <template v-else>
        <transition name="fade">
          <div class="alert alert-warning">
            {{ $t('pbx.service-package.limit.contact_methods') }}
          </div>
        </transition>
      </template>

      <z-form-group class="row">
        <div class="col-10 offset-2">
          <z-form-input>
            <contact-method-list v-model="contact_methods" />
          </z-form-input>
        </div>
      </z-form-group>
    </div>
  </div>
</template>

<script>
  import isEqual from 'lodash-es/isEqual';
  import IconSelect from '@pbx/components/contact-methods/inputs/select-icon';
  import SmartSelectContactMethod from './smart-select-contact-method';
  import ContactMethodList from './contact-method-list';

  export default {
    components: {
      IconSelect,
      SmartSelectContactMethod,
      ContactMethodList
    },
    props: {
      value: {
        type: Array,
        default: () => []
      }
    },

    data() {
      return {
        form: {
          label: 'work'
        },
        contact_methods: []
      };
    },

    computed: {
      is_allow_create_contact_method: function() {
        return this.$user.pbx.limit_contact_methods > this.contact_methods.length;
      }
    },

    watch: {
      value: {
        handler: function(value) {
          this.contact_methods = value || [];
        },
        immediate: true,
        deep: true
      },

      contact_methods: {
        handler: function(contact_methods) {
          if (!isEqual(contact_methods, this.value)) {
            this.$emit('input', contact_methods);
          }
        },
        immediate: true,
        deep: true
      }
    },

    methods: {
      add_contact_method: function(new_item) {
        this.contact_methods = [...this.contact_methods, { ...new_item, label: this.form.label }];
      }
    }
  };
</script>
